<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="grey darken-3"
          icon="mdi-calendar-text"
          :title="$route.params.id ? $t('Edit Weekprogram') : $t('New Weekprogram')"
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem"
          >
          <v-row>
              <v-col>
                <base-date-picker
                        v-model="formValues.from"
                        label="Datum Von"
                        :errors="errors.collect('from')"
                      ></base-date-picker>
              </v-col>
              <v-col>
                <base-date-picker
                        v-model="formValues.to"
                        label="Datum Bis"
                        :errors="errors.collect('to')"
                      ></base-date-picker>
              </v-col>
              <v-col>
                <v-select
                v-model="formValues.weather"
                :items="weathertypes"
                clearable
                label="Wetter anzeigen"
              />
              </v-col>
              <v-col>
                <v-switch
                v-model="formValues.published"
                label="Veröffentlichen"
              />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="8">
                Vorschau
                <br>
                <div class="preview-wrapper">
                  <div v-if="formValues.id">
                    <!-- <iframe class="preview" :src="'http://localhost:8002/wochenprogramm/'+formValues.id"></iframe> -->
                    <iframe class="preview" :src="'/wochenprogramm/'+formValues.id"></iframe>
                  </div>
                </div>
              </v-col>
              <v-col cols="4" >
                <v-card color="grey lighten-5">
                  <v-card-title>{{ $t("Highlights") }}</v-card-title>
                  <v-card-text>
                    <v-list v-if="onlyHighlights && onlyHighlights.length > 0" density="compact">
                          <v-list-item
                            v-for="event in onlyHighlights"
                            :key="event.id"
                          >
                              <v-list-item-title >
                                <v-checkbox class="mt-0" v-model="formValues.events" :label="event.from + ' | ' +event.name" :value="event.id"></v-checkbox>
                              </v-list-item-title>
                          </v-list-item>
                    </v-list>
                    <p v-else>Kein Termine vorhanden</p>
                  </v-card-text>
                </v-card>

                <v-card color="grey lighten-5">
                  <v-card-text>
                    <v-card-title>{{ $t("Veranstaltungen") }}</v-card-title>
                    <v-list v-if="onlyEvents && onlyEvents.length > 0" density="compact">
                          <v-list-item
                            v-for="event in onlyEvents"
                            :key="event.id"
                          >
                              <v-list-item-title >
                                <v-checkbox class="mt-0" v-model="formValues.events" :label="event.from + ' | ' +event.name" :value="event.id"></v-checkbox>
                              </v-list-item-title>
                          </v-list-item>
                    </v-list>
                    <p v-else>Kein Termine vorhanden</p>
  
                  </v-card-text>
                </v-card>
                <v-card color="grey lighten-5">
                  <v-card-title>{{ $t("Ausstellungen") }}</v-card-title>
                  <v-card-text>
                    <v-list v-if="onlyExhibitions && onlyExhibitions.length > 0" density="compact">
                          <v-list-item
                            v-for="event in onlyExhibitions"
                            :key="event.id"
                          >
                              <v-list-item-title >
                                <v-checkbox class="mt-0" v-model="formValues.events" :label="event.from + ' | ' +event.name" :value="event.id"></v-checkbox>
                              </v-list-item-title>
                          </v-list-item>
                    </v-list>
                    <p v-else>Kein Termine vorhanden</p>
                  </v-card-text>
                </v-card>
                <v-card color="grey lighten-5">
                  <v-card-title>{{ $t("Wochenprogramm") }}</v-card-title>
                  <v-card-text>
                    <v-list v-if="onlyWeekprogram && onlyWeekprogram.length > 0" density="compact">
                          <v-list-item
                            v-for="event in onlyWeekprogram"
                            :key="event.id"
                          >
                              <v-list-item-title >
                                <v-checkbox class="mt-0" v-model="formValues.events" :label="event.from + ' | ' + event.name" :value="event.id"></v-checkbox>
                              </v-list-item-title>
                          </v-list-item>
                    </v-list>
                    <p v-else>Kein Termine vorhanden</p>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>


            <v-card-actions class="pl-0">
              <v-btn
                color="primary"
                class="mr-4"
                @click="$router.push({ name: 'weekProgram.index' })"
              >
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-4" @click="saveItem">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { saveItem, fetchItem, fetchEvents } from "../shared/services";
// import draggable from "vuedraggable";
export default {
  // components: {
  //   draggable
  // },
  name: "app-weekProgram-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {
        events: ['1']
      },
      permissions: [],
      loading: true,
      allEvents: [],
      selectedEvents: [],
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        { text: "Email", value: "email" },
        { text: "", value: "action", sortable: false }
      ],
      weathertypes: ["Gross", "Klein"],
    };
  },
  mounted() {
    this.loading = true;
    if(this.$route.params.id){
      fetchItem(this.$route.params.id).then(res => {
          this.formValues = res.data;
        }).then(() => {
            this.getData()
          
          this.loading = false;
        });
    } else{
      this.loading = false;
    }

  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    },
    onlyEvents(){
      if (this.allEvents) {
          return this.allEvents.filter(function (el) { if(el.event_category_id == 1) return el;});
      } else {
        return null;
      }
    },
    onlyExhibitions(){
      if (this.allEvents) {
          return this.allEvents.filter(function (el) { if(el.event_category_id == 2) return el;});
      } else {
        return null;
      }
    },
    onlyWeekprogram(){
      if (this.allEvents) {
          return this.allEvents.filter(function (el) { if(el.event_category_id == 3) return el;});
      } else {
        return null;
      }
    },
    onlyHighlights(){
      if (this.allEvents) {
          return this.allEvents.filter(function (el) { if(el.event_category_id == 4) return el;});
      } else {
        return null;
      }
    }
  },
  methods: {
    getData() {
      return Promise.all([
        this.getAllEvents(),
      ]);
    },
    async getAllEvents() {
      let options = {
        itemsPerPage: -1,
        filters: ['fromDate|'+this.formValues.from, 'toDate|'+this.formValues.to]
      }
      this.allEvents = (await fetchEvents(options)).data;
    },
    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: 'success' });
        if(resp.id){
          this.$router.push({ name: "weekProgram.edit", params: { id: resp.id } });
        } else {
          window.location.reload()
        }
      }
    },
    addRemove(id){
      if(this.formValues.events.includes(id)){
        //existing - remove

      } else {
        //not existing - add
        this.formValues.events.push(id)
      };

    },
    removeAt(idx) {
      this.formValues.events.splice(idx, 1);
    },
  }
};
</script>

<style lang="scss" scoped>

.preview-wrapper {
  max-width: 100%;
  position: relative;
  padding-bottom: 135%; /* 16:9, for an aspect ratio of 1:1 change to this value to 100% */ 
}
iframe.preview{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

</style>
